import {
  buildNormalizedDay,
  buildNormalizedPilotBlueprint,
  localizedGenderNode,
} from "./referenceNormalizerPilotUtils";

/** DNA validator: writing phrase appears in runtime output from buildNormalizedDay + pilot utils. */
export const DNA_VALIDATE_WRITING_PHRASE = "אני שואל/ת את עצמי בשקט";

const days = [
  {
    dayNumber: 1,
    emotionalStage: "pause",
    title: "לקרוא לזה בשם בלי להאשים את עצמי",
    opening: localizedGenderNode(
      [
      "היום אני לא “מקולקל/ת”. היום אני רק מזהה: קשה לי להיפתח."
    ],
      [
      "היום אני לא “מקולקל/ת”. היום אני רק מזהה: קשה לי להיפתח."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "אני עוצר רגע עם עצמי.",
      "נשימה אחת איטית.",
      "אני אומר לעצמי בלב: “הסגירות שלי היא הגנה, לא תקלה.”"
    ],
      [
      "אני עוצר רגע עם עצמי.",
      "נשימה אחת איטית.",
      "אני אומר לעצמי בלב: “הסגירות שלי היא הגנה, לא תקלה.”"
    ]
    ),
    prompts: localizedGenderNode(
      [
      "1. מתי אני מרגיש/ה שאני “נסגר/ת” בדייטים?\n[כאן אני כותב]",
      "2. מה הדבר שאני מפחד/ת שיראו בי אם אפתח?\n[כאן אני כותב]",
      "3. איפה בגוף אני מרגיש/ה את הסגירות הזו?\n[כאן אני כותב]"
    ],
      [
      "1. מתי אני מרגיש/ה שאני “נסגר/ת” בדייטים?\n[כאן אני כותב]",
      "2. מה הדבר שאני מפחד/ת שיראו בי אם אפתח?\n[כאן אני כותב]",
      "3. איפה בגוף אני מרגיש/ה את הסגירות הזו?\n[כאן אני כותב]"
    ]
    ),
    closing: localizedGenderNode(
      [
      "סגירה",
      "היום אני לא נלחם/ת בזה. אני לומד/ת להכיר את ההגנה שלי בעדינות."
    ],
      [
      "סגירה",
      "היום אני לא נלחם/ת בזה. אני לומד/ת להכיר את ההגנה שלי בעדינות."
    ]
    ),
    action: localizedGenderNode(
      "פעם אחת היום: נשימה אחת + משפט: “מותר לי להיפתח לאט.”",
      "פעם אחת היום: נשימה אחת + משפט: “מותר לי להיפתח לאט.”"
    ),
  },
  {
    dayNumber: 2,
    emotionalStage: "pain",
    title: "מה קורה בדיוק ברגע הסגירה",
    opening: localizedGenderNode(
      [
      "היום אני שם לב לרגע הקטן שבו אני משתנה."
    ],
      [
      "היום אני שם לב לרגע הקטן שבו אני משתנה."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "אני עוצר רגע עם עצמי.",
      "נשימה אחת. “אני מתבונן/ת, לא שופט/ת.”"
    ],
      [
      "אני עוצר רגע עם עצמי.",
      "נשימה אחת. “אני מתבונן/ת, לא שופט/ת.”"
    ]
    ),
    prompts: localizedGenderNode(
      [
      "1. מה הטריגר הנפוץ שמסגור אותי? (שאלה, מבט, שתיקה, מגע, ציפייה)\n[כאן אני כותב]",
      "2. מה המחשבה הראשונה שקופצת?\n[כאן אני כותב]",
      "3. מה אני עושה מיד אחר כך? (הומור, נושא אחר, ריחוק, טלפון)\n[כאן אני כותב]"
    ],
      [
      "1. מה הטריגר הנפוץ שמסגור אותי? (שאלה, מבט, שתיקה, מגע, ציפייה)\n[כאן אני כותב]",
      "2. מה המחשבה הראשונה שקופצת?\n[כאן אני כותב]",
      "3. מה אני עושה מיד אחר כך? (הומור, נושא אחר, ריחוק, טלפון)\n[כאן אני כותב]"
    ]
    ),
    closing: localizedGenderNode(
      [
      "סגירה",
      "ברגע שאני מזהה את הרגע — כבר מתחילה בחירה."
    ],
      [
      "סגירה",
      "ברגע שאני מזהה את הרגע — כבר מתחילה בחירה."
    ]
    ),
    action: localizedGenderNode(
      "בפעם הבאה שאני נסגר/ת: עצירת 10 שניות לפני שאני “בורח/ת”.",
      "בפעם הבאה שאני נסגר/ת: עצירת 10 שניות לפני שאני “בורח/ת”."
    ),
  },
  {
    dayNumber: 3,
    emotionalStage: "pain",
    title: "הפחד שמתחת (דחייה / בושה / חדירה)",
    opening: localizedGenderNode(
      [
      "היום אני מזהה את הפחד האמיתי שמתחת לסגירות."
    ],
      [
      "היום אני מזהה את הפחד האמיתי שמתחת לסגירות."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "אני עוצר רגע עם עצמי.",
      "נשימה אחת. “הפחד שלי מנסה להגן עליי.”"
    ],
      [
      "אני עוצר רגע עם עצמי.",
      "נשימה אחת. “הפחד שלי מנסה להגן עליי.”"
    ]
    ),
    prompts: localizedGenderNode(
      [
      "1. ממה אני מפחד/ת יותר: להידחות, להיפגע, או להיראות?\n[כאן אני כותב]",
      "2. איזה משפט ישן אני מאמין/ה בו על אהבה/קשר?\n[כאן אני כותב]",
      "3. איזה משפט עדין יותר יכול להחליף אותו היום?\n[כאן אני כותב]"
    ],
      [
      "1. ממה אני מפחד/ת יותר: להידחות, להיפגע, או להיראות?\n[כאן אני כותב]",
      "2. איזה משפט ישן אני מאמין/ה בו על אהבה/קשר?\n[כאן אני כותב]",
      "3. איזה משפט עדין יותר יכול להחליף אותו היום?\n[כאן אני כותב]"
    ]
    ),
    closing: localizedGenderNode(
      [
      "סגירה",
      "הפחד לא רוצה להיעלם כדי שאהיה אמיתי/ת קצת יותר."
    ],
      [
      "סגירה",
      "הפחד לא רוצה להיעלם כדי שאהיה אמיתי/ת קצת יותר."
    ]
    ),
    action: localizedGenderNode(
      "אני כותב/ת משפט עדין אחד ושומר/ת אותו: “אפשר להיות אני, לאט.”",
      "אני כותב/ת משפט עדין אחד ושומר/ת אותו: “אפשר להיות אני, לאט.”"
    ),
  },
  {
    dayNumber: 4,
    emotionalStage: "pattern",
    title: "“להיפתח” לא אומר לחשוף הכול",
    opening: localizedGenderNode(
      [
      "היום אני מגדיר/ה פתיחות בצורה בטוחה."
    ],
      [
      "היום אני מגדיר/ה פתיחות בצורה בטוחה."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "אני עוצר רגע עם עצמי.",
      "נשימה אחת. “פתיחות יכולה להיות קטנה.”"
    ],
      [
      "אני עוצר רגע עם עצמי.",
      "נשימה אחת. “פתיחות יכולה להיות קטנה.”"
    ]
    ),
    prompts: localizedGenderNode(
      [
      "1. מה זה “פתיחות בטוחה” עבורי? (דוגמא אחת)\n[כאן אני כותב]",
      "2. מה זה “פתיחות גדולה מדי” עבורי?\n[כאן אני כותב]",
      "3. איזה גבול בריא יעזור לי להרגיש מוגן/ת?\n[כאן אני כותב]"
    ],
      [
      "1. מה זה “פתיחות בטוחה” עבורי? (דוגמא אחת)\n[כאן אני כותב]",
      "2. מה זה “פתיחות גדולה מדי” עבורי?\n[כאן אני כותב]",
      "3. איזה גבול בריא יעזור לי להרגיש מוגן/ת?\n[כאן אני כותב]"
    ]
    ),
    closing: localizedGenderNode(
      [
      "סגירה",
      "אני לא רוצה/ת להיפתח מהר. אני בונה אמון בקצב שלי."
    ],
      [
      "סגירה",
      "אני לא רוצה/ת להיפתח מהר. אני בונה אמון בקצב שלי."
    ]
    ),
    action: localizedGenderNode(
      "אני בוחר/ת דבר אחד קטן לספר בפעם הבאה — לא יותר.",
      "אני בוחר/ת דבר אחד קטן לספר בפעם הבאה — לא יותר."
    ),
  },
  {
    dayNumber: 5,
    emotionalStage: "pattern",
    title: "הגוף בדייט (הקפאה / מתח / ניתוק)",
    opening: localizedGenderNode(
      [
      "היום אני מקשיב/ה לגוף במקום להילחם בו."
    ],
      [
      "היום אני מקשיב/ה לגוף במקום להילחם בו."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "אני עוצר רגע עם עצמי.",
      "נשימה אחת איטית. “הגוף מדבר.”"
    ],
      [
      "אני עוצר רגע עם עצמי.",
      "נשימה אחת איטית. “הגוף מדבר.”"
    ]
    ),
    prompts: localizedGenderNode(
      [
      "1. איך הגוף שלי מתנהג בדייט? (קפוא/לחוץ/מכווץ/מנומס מדי)\n[כאן אני כותב]",
      "2. מה הגוף מבקש ממני ברגע הזה? (אוויר, מרחב, הפסקה, מים)\n[כאן אני כותב]",
      "3. מה פעולה קטנה שתעזור לגוף להירגע?\n[כאן אני כותב]"
    ],
      [
      "1. איך הגוף שלי מתנהג בדייט? (קפוא/לחוץ/מכווץ/מנומס מדי)\n[כאן אני כותב]",
      "2. מה הגוף מבקש ממני ברגע הזה? (אוויר, מרחב, הפסקה, מים)\n[כאן אני כותב]",
      "3. מה פעולה קטנה שתעזור לגוף להירגע?\n[כאן אני כותב]"
    ]
    ),
    closing: localizedGenderNode(
      [
      "סגירה",
      "כשאני מרגיע/ה גוף — הלב מקבל מקום."
    ],
      [
      "סגירה",
      "כשאני מרגיע/ה גוף — הלב מקבל מקום."
    ]
    ),
    action: localizedGenderNode(
      "תרגול “נשימה נמוכה”: 3 נשימות לבטן, פעם אחת.",
      "תרגול “נשימה נמוכה”: 3 נשימות לבטן, פעם אחת."
    ),
  },
  {
    dayNumber: 6,
    emotionalStage: "fear",
    title: "הקול הפנימי שמבקר אותי בדייט",
    opening: localizedGenderNode(
      [
      "היום אני מחליף ביקורת בקול שמחזיק."
    ],
      [
      "היום אני מחליף ביקורת בקול שמחזיק."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "אני עוצר רגע עם עצמי.",
      "נשימה אחת. “אני לא רוצה/ת להוכיח.”"
    ],
      [
      "אני עוצר רגע עם עצמי.",
      "נשימה אחת. “אני לא רוצה/ת להוכיח.”"
    ]
    ),
    prompts: localizedGenderNode(
      [
      "1. מה המשפט הביקורתי שחוזר לי?\n[כאן אני כותב]",
      "2. איך הייתי מדבר/ת לחבר טוב במקומי?\n[כאן אני כותב]",
      "3. איך אותו משפט נשמע בגרסה רכה?\n[כאן אני כותב]"
    ],
      [
      "1. מה המשפט הביקורתי שחוזר לי?\n[כאן אני כותב]",
      "2. איך הייתי מדבר/ת לחבר טוב במקומי?\n[כאן אני כותב]",
      "3. איך אותו משפט נשמע בגרסה רכה?\n[כאן אני כותב]"
    ]
    ),
    closing: localizedGenderNode(
      [
      "סגירה",
      "קול רך לא הופך אותי לחלש/ה. הוא מאפשר לי להיות אמיתי/ת."
    ],
      [
      "סגירה",
      "קול רך לא הופך אותי לחלש/ה. הוא מאפשר לי להיות אמיתי/ת."
    ]
    ),
    action: localizedGenderNode(
      "פעם אחת היום: אני עונה לביקורת במשפט הרך שלי.",
      "פעם אחת היום: אני עונה לביקורת במשפט הרך שלי."
    ),
  },
  {
    dayNumber: 7,
    emotionalStage: "need",
    title: "חשיפה נקייה (ACT עדין): להישאר עוד דקה",
    opening: localizedGenderNode(
      [
      "היום אני מתרגל/ת להישאר רגע בתוך אי־נוחות בלי לברוח."
    ],
      [
      "היום אני מתרגל/ת להישאר רגע בתוך אי־נוחות בלי לברוח."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "אני עוצר רגע עם עצמי.",
      "נשימה אחת. “אני יכול/ה להחזיק דקה.”"
    ],
      [
      "אני עוצר רגע עם עצמי.",
      "נשימה אחת. “אני יכול/ה להחזיק דקה.”"
    ]
    ),
    prompts: localizedGenderNode(
      [
      "1. באיזה רגע אני נוטה לברוח?\n[כאן אני כותב]",
      "2. אם אני נשאר/ת עוד דקה — מה אני חושש/ת שיקרה?\n[כאן אני כותב]",
      "3. מה קרה בפועל כשנשארתי עוד דקה (אפילו בדמיון)?\n[כאן אני כותב]"
    ],
      [
      "1. באיזה רגע אני נוטה לברוח?\n[כאן אני כותב]",
      "2. אם אני נשאר/ת עוד דקה — מה אני חושש/ת שיקרה?\n[כאן אני כותב]",
      "3. מה קרה בפועל כשנשארתי עוד דקה (אפילו בדמיון)?\n[כאן אני כותב]"
    ]
    ),
    closing: localizedGenderNode(
      [
      "סגירה",
      "אומץ הוא לא פתיחות ענקית. אומץ הוא עוד דקה."
    ],
      [
      "סגירה",
      "אומץ הוא לא פתיחות ענקית. אומץ הוא עוד דקה."
    ]
    ),
    action: localizedGenderNode(
      "בפעם הבאה: “עוד דקה אחת” לפני שאני סוגר/ת.",
      "בפעם הבאה: “עוד דקה אחת” לפני שאני סוגר/ת."
    ),
  },
  {
    dayNumber: 8,
    emotionalStage: "softening",
    title: "לשים גבולות בלי להיסגר",
    opening: localizedGenderNode(
      [
      "היום אני לומד/ת: גבול יכול להיות פתוח."
    ],
      [
      "היום אני לומד/ת: גבול יכול להיות פתוח."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "אני עוצר רגע עם עצמי.",
      "נשימה אחת. “גבול הוא שמירה, לא קיר.”"
    ],
      [
      "אני עוצר רגע עם עצמי.",
      "נשימה אחת. “גבול הוא שמירה, לא קיר.”"
    ]
    ),
    prompts: localizedGenderNode(
      [
      "1. איפה אני בוחר/ת/ה גבול בדייטים?\n[כאן אני כותב]",
      "2. איך אני יכול/ה להגיד גבול בצורה רכה?\n[כאן אני כותב]",
      "3. מה הפחד שלי אם אשים גבול?\n[כאן אני כותב]"
    ],
      [
      "1. איפה אני בוחר/ת/ה גבול בדייטים?\n[כאן אני כותב]",
      "2. איך אני יכול/ה להגיד גבול בצורה רכה?\n[כאן אני כותב]",
      "3. מה הפחד שלי אם אשים גבול?\n[כאן אני כותב]"
    ]
    ),
    closing: localizedGenderNode(
      [
      "סגירה",
      "כשיש גבול — פחות בוחר/ת שריון."
    ],
      [
      "סגירה",
      "כשיש גבול — פחות בוחר/ת שריון."
    ]
    ),
    action: localizedGenderNode(
      "אני מכין/ה משפט גבול רך אחד לשימוש עתידי.",
      "אני מכין/ה משפט גבול רך אחד לשימוש עתידי."
    ),
  },
  {
    dayNumber: 9,
    emotionalStage: "softening",
    title: "מי אני כשאני לא “מופיע/ה”",
    opening: localizedGenderNode(
      [
      "היום אני משחרר/ת פרפורמנס ומחזיר/ה אנושיות."
    ],
      [
      "היום אני משחרר/ת פרפורמנס ומחזיר/ה אנושיות."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "אני עוצר רגע עם עצמי.",
      "נשימה אחת. “אני לא הצגה.”"
    ],
      [
      "אני עוצר רגע עם עצמי.",
      "נשימה אחת. “אני לא הצגה.”"
    ]
    ),
    prompts: localizedGenderNode(
      [
      "1. מה אני מנסה “להיראות” בדייט?\n[כאן אני כותב]",
      "2. מה קורה לי כשאני מנסה להרשים?\n[כאן אני כותב]",
      "3. מה אמת אנושית אחת שאני מוכן/ה להביא?\n[כאן אני כותב]"
    ],
      [
      "1. מה אני מנסה “להיראות” בדייט?\n[כאן אני כותב]",
      "2. מה קורה לי כשאני מנסה להרשים?\n[כאן אני כותב]",
      "3. מה אמת אנושית אחת שאני מוכן/ה להביא?\n[כאן אני כותב]"
    ]
    ),
    closing: localizedGenderNode(
      [
      "סגירה",
      "אנשים מתחברים לאמת, לא לשלמות."
    ],
      [
      "סגירה",
      "אנשים מתחברים לאמת, לא לשלמות."
    ]
    ),
    action: localizedGenderNode(
      "אני מתרגל/ת משפט אחד פשוט: “האמת? קצת קשה לי להיפתח לאט.”",
      "אני מתרגל/ת משפט אחד פשוט: “האמת? קצת קשה לי להיפתח לאט.”"
    ),
  },
  {
    dayNumber: 10,
    emotionalStage: "perspective",
    title: "אמון נבנה במנות קטנות",
    opening: localizedGenderNode(
      [
      "היום אני לא מחפש/ת “קליק”. אני בונה אמון."
    ],
      [
      "היום אני לא מחפש/ת “קליק”. אני בונה אמון."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "אני עוצר רגע עם עצמי.",
      "נשימה אחת. “אמון זה תהליך.”"
    ],
      [
      "אני עוצר רגע עם עצמי.",
      "נשימה אחת. “אמון זה תהליך.”"
    ]
    ),
    prompts: localizedGenderNode(
      [
      "1. מה גורם לי להרגיש בטוח/ה עם אדם?\n[כאן אני כותב]",
      "2. מה סימן קטן שמראה לי שזה אדם בטוח?\n[כאן אני כותב]",
      "3. מה סימן קטן שמראה לי שלא?\n[כאן אני כותב]"
    ],
      [
      "1. מה גורם לי להרגיש בטוח/ה עם אדם?\n[כאן אני כותב]",
      "2. מה סימן קטן שמראה לי שזה אדם בטוח?\n[כאן אני כותב]",
      "3. מה סימן קטן שמראה לי שלא?\n[כאן אני כותב]"
    ]
    ),
    closing: localizedGenderNode(
      [
      "סגירה",
      "אני לא רוצה/ת להיפתח למי שלא בטוח לי."
    ],
      [
      "סגירה",
      "אני לא רוצה/ת להיפתח למי שלא בטוח לי."
    ]
    ),
    action: localizedGenderNode(
      "אני כותב/ת 2 סימני “בטוח” ו-2 סימני “לא בטוח” ושומר/ת.",
      "אני כותב/ת 2 סימני “בטוח” ו-2 סימני “לא בטוח” ושומר/ת."
    ),
  },
  {
    dayNumber: 11,
    emotionalStage: "strength",
    title: "לשאול שאלה אמיתית במקום להסתתר",
    opening: localizedGenderNode(
      [
      "היום אני יוצר/ת קשר דרך סקרנות, לא דרך מאמץ."
    ],
      [
      "היום אני יוצר/ת קשר דרך סקרנות, לא דרך מאמץ."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "אני עוצר רגע עם עצמי.",
      "נשימה אחת. “סקרנות פותחת בעדינות.”"
    ],
      [
      "אני עוצר רגע עם עצמי.",
      "נשימה אחת. “סקרנות פותחת בעדינות.”"
    ]
    ),
    prompts: localizedGenderNode(
      [
      "1. על מה הייתי רוצה באמת לדעת על האדם מולי?\n[כאן אני כותב]",
      "2. מה שאלה אחת פשוטה שאני יכול/ה לשאול?\n[כאן אני כותב]",
      "3. מה אני מפחד/ת לשאול ולמה?\n[כאן אני כותב]"
    ],
      [
      "1. על מה הייתי רוצה באמת לדעת על האדם מולי?\n[כאן אני כותב]",
      "2. מה שאלה אחת פשוטה שאני יכול/ה לשאול?\n[כאן אני כותב]",
      "3. מה אני מפחד/ת לשאול ולמה?\n[כאן אני כותב]"
    ]
    ),
    closing: localizedGenderNode(
      [
      "סגירה",
      "פתיחות היא גם לשאול, לא רק לספר."
    ],
      [
      "סגירה",
      "פתיחות היא גם לשאול, לא רק לספר."
    ]
    ),
    action: localizedGenderNode(
      "אני בוחר/ת שאלה אחת “אמיתית” לשימוש בדייט הבא.",
      "אני בוחר/ת שאלה אחת “אמיתית” לשימוש בדייט הבא."
    ),
  },
  {
    dayNumber: 12,
    emotionalStage: "release",
    title: "כשהדייט “לא עובד” בלי לקחת את זה עליי",
    opening: localizedGenderNode(
      [
      "היום אני מפריד/ה בין התאמה לבין ערך עצמי."
    ],
      [
      "היום אני מפריד/ה בין התאמה לבין ערך עצמי."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "אני עוצר רגע עם עצמי.",
      "נשימה אחת. “אי־התאמה היא לא דחייה של מי שאני.”"
    ],
      [
      "אני עוצר רגע עם עצמי.",
      "נשימה אחת. “אי־התאמה היא לא דחייה של מי שאני.”"
    ]
    ),
    prompts: localizedGenderNode(
      [
      "1. מה אני מפרש/ת מיד ככישלון?\n[כאן אני כותב]",
      "2. מה הסבר אפשרי נוסף, נייטרלי יותר?\n[כאן אני כותב]",
      "3. מה אני רוצה לזכור על הערך שלי גם אם זה לא עובד?\n[כאן אני כותב]"
    ],
      [
      "1. מה אני מפרש/ת מיד ככישלון?\n[כאן אני כותב]",
      "2. מה הסבר אפשרי נוסף, נייטרלי יותר?\n[כאן אני כותב]",
      "3. מה אני רוצה לזכור על הערך שלי גם אם זה לא עובד?\n[כאן אני כותב]"
    ]
    ),
    closing: localizedGenderNode(
      [
      "סגירה",
      "אני לא נמדד/ת לפי דייט אחד."
    ],
      [
      "סגירה",
      "אני לא נמדד/ת לפי דייט אחד."
    ]
    ),
    action: localizedGenderNode(
      "אחרי אינטראקציה: אני כותב/ת 1 דבר שעשיתי נכון.",
      "אחרי אינטראקציה: אני כותב/ת 1 דבר שעשיתי נכון."
    ),
  },
  {
    dayNumber: 13,
    emotionalStage: "choice",
    title: "“אני מוכן/ה לקשר” במובן שלי",
    opening: localizedGenderNode(
      [
      "היום אני מנסח/ת מה אני רוצה באמת בקשר."
    ],
      [
      "היום אני מנסח/ת מה אני רוצה באמת בקשר."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "אני עוצר רגע עם עצמי.",
      "נשימה אחת. “מותר לי לרצות קשר שמתאים לי.”"
    ],
      [
      "אני עוצר רגע עם עצמי.",
      "נשימה אחת. “מותר לי לרצות קשר שמתאים לי.”"
    ]
    ),
    prompts: localizedGenderNode(
      [
      "1. איך אני רוצה להרגיש בתוך קשר?\n[כאן אני כותב]",
      "2. איזה ערך אחד רוצה להיות שם?\n[כאן אני כותב]",
      "3. מה גבול אחד שיגן עליי בקשר הבא?\n[כאן אני כותב]"
    ],
      [
      "1. איך אני רוצה להרגיש בתוך קשר?\n[כאן אני כותב]",
      "2. איזה ערך אחד רוצה להיות שם?\n[כאן אני כותב]",
      "3. מה גבול אחד שיגן עליי בקשר הבא?\n[כאן אני כותב]"
    ]
    ),
    closing: localizedGenderNode(
      [
      "סגירה",
      "בהירות יוצרת ביטחון."
    ],
      [
      "סגירה",
      "בהירות יוצרת ביטחון."
    ]
    ),
    action: localizedGenderNode(
      "אני כותב/ת “משפט כיוון” אחד לקשר הבא ושומר/ת.",
      "אני כותב/ת “משפט כיוון” אחד לקשר הבא ושומר/ת."
    ),
  },
  {
    dayNumber: 14,
    emotionalStage: "continuation",
    title: "סגירה רכה: להיפתח לאט זו יכולת",
    opening: localizedGenderNode(
      [
      "היום אני סוגר/ת את המסע עם נאמנות לעצמי."
    ],
      [
      "היום אני סוגר/ת את המסע עם נאמנות לעצמי."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "אני עוצר רגע עם עצמי.",
      "נשימה אחת איטית. “אני לא מאחר/ת. אני מדויק/ת לעצמי.”"
    ],
      [
      "אני עוצר רגע עם עצמי.",
      "נשימה אחת איטית. “אני לא מאחר/ת. אני מדויק/ת לעצמי.”"
    ]
    ),
    prompts: localizedGenderNode(
      [
      "1. מה למדתי על ההגנה שלי?\n[כאן אני כותב]",
      "2. מה צעד קטן אחד של פתיחות אני מוכן/ה להמשיך איתו?\n[כאן אני כותב]",
      "3. משפט חזרה לימים של סגירה:\n[כאן אני כותב]"
    ],
      [
      "1. מה למדתי על ההגנה שלי?\n[כאן אני כותב]",
      "2. מה צעד קטן אחד של פתיחות אני מוכן/ה להמשיך איתו?\n[כאן אני כותב]",
      "3. משפט חזרה לימים של סגירה:\n[כאן אני כותב]"
    ]
    ),
    closing: localizedGenderNode(
      [
      "סגירה סופית למסע",
      "אני לא מכריח/ה את עצמי להיפתח.",
      "אני מלמד/ת את עצמי להרגיש בטוח/ה.",
      "לאט, בשקט, עם עצמי.",
      "וזה כוח."
    ],
      [
      "סגירה סופית למסע",
      "אני לא מכריח/ה את עצמי להיפתח.",
      "אני מלמד/ת את עצמי להרגיש בטוח/ה.",
      "לאט, בשקט, עם עצמי.",
      "וזה כוח."
    ]
    ),
    action: localizedGenderNode(
      "אני בוחר/ת פעולה אחת שמסמלת “פתיחות קטנה”: הודעה כנה קצרה / שיחה קצרה / יציאה אחת בלי לחץ.",
      "אני בוחר/ת פעולה אחת שמסמלת “פתיחות קטנה”: הודעה כנה קצרה / שיחה קצרה / יציאה אחת בלי לחץ."
    ),
  },
].map(buildNormalizedDay);

export const difficultyOpeningUpOnDatesBlueprintHe = buildNormalizedPilotBlueprint({
  id: "difficulty_opening_up_on_dates_14d",
  version: "tri_locale_emit_he_v1",
  durationDays: 14,
  problemKey: "difficulty_opening_up_on_dates",
  category: "general",
  journeyName: {
    he: "קושי להיפתח בדייטים",
    en: "Difficulty Opening Up on Dates",
    es: "Dificultad para abrirme en citas",
  },
  days,
});

export default difficultyOpeningUpOnDatesBlueprintHe;
